import React, { useState, useContext, useEffect } from 'react';
import MenuButton from './buttons/MenuButton';

import { SessionContext } from "../context/session-context";

export default function LogoutDialog(props) {

  const [state, dispatch] = useContext(SessionContext);
  const [processing, setProcessing] = useState(false);
 
  const handleSubmit = () => {
    setProcessing(true);
  };

  useEffect(() => {
    if (processing){
      const abortController = new AbortController();

      const request = {   
        ident:state.ident
      };

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/logout', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            dispatch({
              type: "end",
              payload: { }
            });
          }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
    }

  }, [processing, state.ident, dispatch]);

  return (
    <div>
      <MenuButton label="Logout" handleClick={handleSubmit} disabled={false} tooltip={'Logout of Mapdata data portal'}/>
    </div>
  );
}
